var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodataSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.333,
    height: 115,
    viewBox: "0 0 130.333 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodata-small",
    transform: "translate(-597.349 -254.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13899",
    "data-name": "Path 13899",
    d: "M682.252,286.424c0-.063,0-.126-.008-.187C682.247,286.3,682.25,286.361,682.252,286.424Z",
    transform: "translate(45.429 16.779)",
    fill: "#005ef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13900",
    "data-name": "Path 13900",
    d: "M682.25,286.419h0v0Z",
    transform: "translate(45.432 16.844)",
    fill: "#0f3872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13901",
    "data-name": "Path 13901",
    d: "M682.277,286.476a4.281,4.281,0,0,0-.091-.685l0,.009A4.29,4.29,0,0,1,682.277,286.476Z",
    transform: "translate(45.396 16.541)",
    fill: "#0f3872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13902",
    "data-name": "Path 13902",
    d: "M680.627,284.218a1.461,1.461,0,0,1,.183.012A1.461,1.461,0,0,0,680.627,284.218Z",
    transform: "translate(44.559 15.702)",
    fill: "#005ef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13903",
    "data-name": "Path 13903",
    d: "M680.746,284.226a2.859,2.859,0,0,1,2.21,2.413l0-.009A2.821,2.821,0,0,0,680.746,284.226Z",
    transform: "translate(44.623 15.705)",
    fill: "#005ef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13904",
    "data-name": "Path 13904",
    d: "M716.322,296.691a4.454,4.454,0,0,0-.1-.937,3.725,3.725,0,0,1-.592,1.369h-.012a3.7,3.7,0,0,0,.6-1.378,3.238,3.238,0,0,0-1.369-2.1l-39.571-24a15.885,15.885,0,0,0-1.909-.991,14.933,14.933,0,0,0-1.924-.688,13.994,13.994,0,0,0-7.645,0,15.018,15.018,0,0,0-1.924.688,15.864,15.864,0,0,0-1.907.991l-39.571,24a3.235,3.235,0,0,0-1.37,2.1,3.7,3.7,0,0,0,.6,1.378h-.014a3.694,3.694,0,0,1-.591-1.369,4.344,4.344,0,0,0-.1.937c0,.146.009.29.023.432h-.023V330.81h97.294V297.633A4.354,4.354,0,0,0,716.322,296.691Z",
    transform: "translate(11.36 6.702)",
    fill: "#0d3f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13905",
    "data-name": "Path 13905",
    d: "M704.225,343.194H625.472s-2.4-85.6,0-87.521c2.522-2.019,61.44,0,61.44,0l17.312,19.6Z",
    transform: "translate(14.31 0)",
    fill: "#ebebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13906",
    "data-name": "Path 13906",
    d: "M665.046,255.36c1.658,0,15.894,13.218,17.312,19.6.271,1.217-14.51-3.5-15.567-4.291C665.632,269.8,665.046,255.36,665.046,255.36Z",
    transform: "translate(36.176 0.313)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10131",
    "data-name": "Rectangle 10131",
    width: 40.767,
    height: 2.687,
    rx: 0.874,
    transform: "translate(656.11 262.678)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10132",
    "data-name": "Rectangle 10132",
    width: 40.767,
    height: 2.686,
    rx: 0.874,
    transform: "translate(656.11 268.293)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10133",
    "data-name": "Rectangle 10133",
    width: 41.338,
    height: 2.686,
    rx: 0.874,
    transform: "translate(655.824 274.515)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13907",
    "data-name": "Path 13907",
    d: "M716.322,286.408a3.544,3.544,0,0,1-1.472,3.033l-38.726,25.106-.691.447c-.346.21-.7.4-1.049.584l.269.194-13.661-.287q-.438-.23-.869-.49l-.855-.552-38.87-25a3.543,3.543,0,0,1-1.473-3.033V340.09a3.221,3.221,0,0,0,2.487,3.383c22.966,4.03,55.381,5.692,92.423,0a3.2,3.2,0,0,0,2.487-3.383V286.408Z",
    transform: "translate(11.36 16.744)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13908",
    "data-name": "Path 13908",
    d: "M713.835,335.238a2.845,2.845,0,0,0,1.994-1.432l-41.8-28.945c-2.115-1.807-4.365-3.1-6.6-3.1-2.3,0-3.859.851-6.786,3l-41.709,24.5v2.582a3.221,3.221,0,0,0,2.487,3.383C644.378,339.267,676.793,340.929,713.835,335.238Z",
    transform: "translate(11.36 24.978)",
    fill: "#055fa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13909",
    "data-name": "Path 13909",
    d: "M641.732,275.608c-1.1.177-3.641,3.788-3.013,4.644s31.69,22.062,32.748,21.823,3.53-4.432,3.651-5.822S643.36,275.35,641.732,275.608Z",
    transform: "translate(22.039 11.091)",
    fill: "#f23427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13910",
    "data-name": "Path 13910",
    d: "M639.291,298.935c-.188,1.1,2.421,4.659,3.434,4.342s31.1-22.884,31.212-23.963-3.067-4.762-4.347-5.325S639.57,297.313,639.291,298.935Z",
    transform: "translate(22.395 10.223)",
    fill: "#f23427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13911",
    "data-name": "Path 13911",
    d: "M601.41,296.827c-.125.814,2.685,8.3,3.921,8.391,2.095.158,38.47-18.168,39.522-18.675a55.237,55.237,0,0,0,5.822-5.91c-2.09-1.284,2.245-3.309.423-3.97a5.851,5.851,0,0,1-1.358-.174,80.6,80.6,0,0,0-8.4,1.725C639.769,278.682,601.535,296.011,601.41,296.827Z",
    transform: "translate(2.183 11.56)",
    fill: "#ffd4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13912",
    "data-name": "Path 13912",
    d: "M602.921,301.089c.6,1.155,1.183,2.011,1.595,2.043,2.095.158,38.47-18.168,39.522-18.675a35.489,35.489,0,0,0,4.147-4.077A387.854,387.854,0,0,0,602.921,301.089Z",
    transform: "translate(2.998 13.637)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13913",
    "data-name": "Path 13913",
    d: "M601.41,296.677a10.823,10.823,0,0,0,.784,2.782,270.253,270.253,0,0,0,45.014-22.689c-2.315.424-4.613.922-5.869,1.3C639.769,278.532,601.535,295.861,601.41,296.677Z",
    transform: "translate(2.183 11.714)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13914",
    "data-name": "Path 13914",
    d: "M601.919,299.609a33.743,33.743,0,0,0,1.541,3.566c14.776-7.577,29.973-13.94,45.263-20.709.56-.6,1.127-1.223,1.675-1.833-2.09-1.284,2.246-3.309.423-3.97a5.851,5.851,0,0,1-1.358-.174c-.811.126-1.67.273-2.53.43C631.892,285.774,617.389,292.1,601.919,299.609Z",
    transform: "translate(2.459 11.562)",
    fill: "#f7d17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13915",
    "data-name": "Path 13915",
    d: "M627.3,279.921c.952,1.2,2.744-.286,3.324.957.872,1.865-2.057,2.237-.946,3.93.506.771,2.044.445,2.719.634,1.186-1.168,2.873-2.965,4.394-4.659a31.839,31.839,0,0,0,3.61-4.415c.034-.316-2.013-.121-4.545.272-2.831.441-6.269,1.131-8.093,1.638C627.425,278.911,627.031,279.582,627.3,279.921Z",
    transform: "translate(15.97 11.426)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13916",
    "data-name": "Path 13916",
    d: "M634.866,278.98a15.144,15.144,0,0,0,2.021-2.612c.028-.255-1.3-.177-3.147.069A10.219,10.219,0,0,0,634.866,278.98Z",
    transform: "translate(19.471 11.43)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13917",
    "data-name": "Path 13917",
    d: "M600.959,300.484c.541.2,3.684-1.34,3.811-1.777s-3.685-7.886-4.048-7.953a10.7,10.7,0,0,0-3.344,1.559C597.041,292.706,599.7,300.027,600.959,300.484Z",
    transform: "translate(0 19.177)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13918",
    "data-name": "Path 13918",
    d: "M603.286,299.891c.531.081,4.222-1.549,3.8-1.913-.728-.631-4.376-7.253-3.919-8.391.292-.728-3.6,1.632-3.856,1.8S602.214,299.728,603.286,299.891Z",
    transform: "translate(1.049 18.482)",
    fill: "#f7d17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13919",
    "data-name": "Path 13919",
    d: "M605.834,295.827c.418,1.327,1.657,5.191,1.878,5.216.266.029,4.385-.949,4.626-.948a6.231,6.231,0,0,1,1.557,2.518s-6.718.741-7.1.593c-.314-.12-1.778-4.974-2.352-6.859A3.3,3.3,0,0,0,605.834,295.827Z",
    transform: "translate(3.816 21.886)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13920",
    "data-name": "Path 13920",
    d: "M606.156,328.419c-.391.052-1.744-3.586-1.523-4.326s1.375-.8,1.375-.622S606.819,328.33,606.156,328.419Z",
    transform: "translate(3.906 36.574)",
    fill: "#394678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13921",
    "data-name": "Path 13921",
    d: "M616.858,331.145c-.288.269-3.5-1.911-3.751-2.642s.657-1.449.76-1.3S617.347,330.689,616.858,331.145Z",
    transform: "translate(8.408 38.608)",
    fill: "#394678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13922",
    "data-name": "Path 13922",
    d: "M621.63,308.88s-1.007,15.426-1.483,19.159-1.423,10.665-1.423,10.665c-.328.519-1.246,0-1.246,0s-.323-12.19-.146-12.842-.329-7.955-.329-7.955-.489,7.05-1.469,8-9.328,7.583-9.92,7.406-.475-.948-.475-.948,7.12-8.059,7.593-8.178-1.543-13.688-.3-15.7,5.162-1.275,5.162-1.275Z",
    transform: "translate(4.187 27.828)",
    fill: "#004990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13923",
    "data-name": "Path 13923",
    d: "M619.465,308.22s.186,1.993-.319,2.327-1.966,1.332-5.821.59c-3.235-.621-4.45-1.111-3.435-3.272C610.842,305.839,619.465,308.22,619.465,308.22Z",
    transform: "translate(6.561 27.873)",
    fill: "#fee87d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13924",
    "data-name": "Path 13924",
    d: "M621.28,285.086c.32-.069.712.5.741.919s0,3.91,0,3.91h-.86S620.034,285.353,621.28,285.086Z",
    transform: "translate(12.492 16.158)",
    fill: "#fccba9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13925",
    "data-name": "Path 13925",
    d: "M620.4,286.137c-.318.114.225,1.73.54,1.985a3.074,3.074,0,0,1,.572.667S620.768,286,620.4,286.137Z",
    transform: "translate(12.282 16.721)",
    fill: "#f7d17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13926",
    "data-name": "Path 13926",
    d: "M625.46,287.977h-1.306s-1.186,6.992-1.661,7.585-3.41,4.28-5.2,5.377a6.037,6.037,0,0,1-2.15.9,3.557,3.557,0,0,0,0,3.318c.949,1.659,1.067.591,1.067.591s6.95-6.354,7.83-9.124C624.807,294.2,625.7,288.925,625.46,287.977Z",
    transform: "translate(9.289 17.689)",
    fill: "#febd07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13927",
    "data-name": "Path 13927",
    d: "M614.71,293.193s2.8,1.052,2.7,2.281a1.524,1.524,0,0,1-1.052,1.452l-.3,2.712h-.937l-1.78-1.853s.46-2.607.489-2.652S614.71,293.193,614.71,293.193Z",
    transform: "translate(8.559 20.483)",
    fill: "#fccba9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13928",
    "data-name": "Path 13928",
    d: "M618.111,296.713s-.111,1.132-1.535.822a6.524,6.524,0,0,1-2.158-.822l-2.581,5.553.757.954a6.428,6.428,0,0,1-1.157,4.512c-.737,1.145-3.381,6.355.045,7.245s6.852,1.51,7.875-.756,1.023-8.354.607-11.081C619.837,302.3,618.667,296.828,618.111,296.713Z",
    transform: "translate(6.682 22.342)",
    fill: "#fee87d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13929",
    "data-name": "Path 13929",
    d: "M617.914,292.84c-.646-1.181-3.442-.608-4.11.667s-.594,2.65-.875,2.857-2.507,1.364-3.055,3.334-.578,5.036,1.2,5.718,5.145-.207,5.828-2.208-.251-5.019-.445-6.177-.074-1.584.059-1.644S618.875,294.6,617.914,292.84Z",
    transform: "translate(6.562 19.943)",
    fill: "#e3761e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13930",
    "data-name": "Path 13930",
    d: "M604.535,296.343a1.458,1.458,0,0,1-.683-1.026c-.088-.741.289-.856,1.091-.856s1.247.026,1.294.619a1.681,1.681,0,0,1-.218,1.037s.052.168.14.443a3.3,3.3,0,0,1-1.393.519C604.632,296.641,604.546,296.363,604.535,296.343Z",
    transform: "translate(3.492 21.163)",
    fill: "#fccba9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataSmall);
export default __webpack_public_path__ + "static/media/nodata-small.1f411d0a3f436c0244b31131f75c565f.svg";
export { ForwardRef as ReactComponent };